import React from 'react';
import { CellProps, WithClassname } from '@jsonforms/core';
import { ChakraInputNumber } from './ChakraInputNumber';
import { namedMemo } from '@/utils/namedMemo';

export const ChakraInputInteger = namedMemo('ChakraInputInteger', (props: CellProps & WithClassname) => {
    return <ChakraInputNumber {...props} step={1} />;
});
